<template>
  <div class="bg_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="二手房交易评价"
      fontSize="0.32rem"
    />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div v-if="current === 1">
            <div class="inner" v-for="(item, index) in list" :key="index">
              <div class="top m_flex_box flex_vc flex_jz">
                <h4 class="line_comp1">合同号：{{item.contrDateNum}}{{item.contrNum}}</h4>
                <i class="bg_ori" v-if="item.contrState == 0">已保存</i>
                <i class="bg_ori" v-if="item.contrState == 1">已签约</i>
                <i class="bg_ori" v-if="item.contrState == 2">已上传签字页</i>
                <i class="bg_ori" v-if="item.contrState == 3">已备案</i>
                <i class="bg_ori" v-if="item.contrState == 4">已注销</i>
              </div>
              <div class="middle">
                <div class="row">{{item.houseUse ? item.houseUse : '-'}}<i>|</i>{{item.sumArea}}m²<i>|</i>{{item.sumPrice / 10000}}万</div>
                <div class="row_light m_flex_box flex_jz">
                  <p v-if="item.contrType == 0">合同类型：线上合同</p>
                  <p v-if="item.contrType == 1">合同类型：线下合同</p>
                  <p v-if="item.contrType == 2">合同类型：中介合同</p>
                  <p>出卖方：{{item.bargainor}}</p>
                  <p>买受方：{{item.purchaser}}</p>
                </div>
                <div class="row_light">房屋坐落：{{item.houseAddress}}</div>
              </div>
              <div class="btn_con m_flex_box flex_vc flex_he">
                <span  v-show="item.contrType === '0'&&item.bargainorId&&item.onlineUserId == item.bargainorId&&(!item.contractEvaluates.beEvaluateType == 1||item.contractEvaluates.length==0)"        @click="toUrl('/argumentClf',{id:item.id,type:1})">评价买方</span>
                <span   v-show="item.contrType === '0'&&item.purchaserId&&item.onlineUserId == item.purchaserId&&(!item.contractEvaluates.beEvaluateType == 0||item.contractEvaluates.length==0)"        @click="toUrl('/argumentClf',{id:item.id,type:0})">评价卖方</span>
                <span   v-show="item.contrType === '1'&&(!item.contractEvaluates.beEvaluateType == 5||item.contractEvaluates.length==0)"         @click="toUrl('/argumentClf',{id:item.id,type:5})">评价工作人员</span>
                <span    v-show="item.contrType === '2'&&(!item.contractEvaluates.beEvaluateType == 2||item.contractEvaluates.length==0)"      @click="toUrl('/argumentClf',{id:item.id,type:2})">评价机构</span>
                <span    v-show="item.contrType === '2'&&(!item.contractEvaluates.beEvaluateType == 3||item.contractEvaluates.length==0)"      @click="toUrl('/argumentClf',{id:item.id,type:3})">评价网签代办点</span>
                <span    v-show="item.contrType === '2'&&(!item.contractEvaluates.beEvaluateType == 4||item.contractEvaluates.length==0)"      @click="toUrl('/argumentClf',{id:item.id,type:4})">评价操作员</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <img class="to_home" @click="$router.replace('/mine')" src="@/assets/img/index/99.png" alt="">
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      current: 1,
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      currPageNo: 1,
    };
  },
  components: {
    topHeader
  },
  mounted() {},
  methods: {
    toUrl(path, query){
      this.$router.push({
        path,
        query
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, 'list', [])
      this.onLoad(1);
    },
    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http.post('cms/contractData/reg/getMyEvaluate.do', qs.stringify({
          pageSize: 10,
          offset: (this.currPageNo-1) * 10,
        })).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows);
            this.loading = false;
            this.currPageNo += 1;
          } else {
            this.finished = true;
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.cover_innr{
  font-size: 0.24rem;
  .row{
    margin-bottom: 0.2rem;
    p{
      width: 55%;
    }
    p:nth-child(2){
      width: 42%;
    }
  }
  .row_{
    margin-bottom: 0.2rem;
  }
}
.bg_gray{
  background-color: #f5f5f5;
  min-height: 100vh;
}
.inner{
  background-color: #fff;
  padding: 0.3rem 0.23rem 0;
  border-bottom: 0.16rem solid #f5f5f5;
  .top{
    h4{
      font-size: 0.32rem;
      font-weight: 800;
    }
    i{
      padding: 0.02rem 0.04rem;
      color: #fff;
      font-size: 0.2rem;
      text-align: center;
      border-radius: 0.02rem;
      &.bg_ori{
        background-color: #FF5C3C;
      }
      &.bg_gra{
        background-color: #A0A0A0;
      }
    }
  }
  .middle{
    padding: 0.2rem 0 0.1rem;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.24rem;
    .row{
      margin-bottom: 0.16rem;
      i{
        margin: 0 0.1rem;
      }
    }
    .row_light{
      margin-bottom: 0.16rem;
      color: #666666;
    }
  }
  .btn_con{
    height: 1.08rem;
    padding: 0.25rem 0.23rem;
    box-sizing: border-box;
    span{
      height: 0.58rem;
      width: 1.4rem;
      text-align: center;
      line-height: 0.58rem;
      box-sizing: border-box;
      border: 1px solid #CCCCCC;
      color: #666;
      border-radius: 0.08rem;
      margin-left: 0.14rem;
      &:last-child{
        border: 1px solid #2F72F5;
        color: #2F72F5;
      }
    }
  }
}
</style>